import api from "@/lib/axios";

// Kabaca yazılmış açıklamayı menüye uygun hale getirir. Sağlayıcıyı API seçiyor (bkz. translate).
// name ve category bağlam olarak gider. Boş/başarısızsa '' döner — çağıran mevcut metni korur.
export const improveDescription = async (text, name, category) => {
  const trimmed = (text ?? "").trim();
  if (!trimmed) {
    return "";
  }
  const { data } = await api.post("/improve", {
    text: trimmed,
    name: name || undefined,
    category: category || undefined,
  });
  return data.data.text ?? "";
};
